import useHeaderMenuByUser from "@/hooks/data/useHeaderMenuByUser";
import { createContext } from "react"

export interface IHeaderMenuContext extends ReturnType<typeof useHeaderMenuByUser> {
}

export const HeaderMenuContext = createContext<IHeaderMenuContext>({
    data: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default HeaderMenuContext;